import { render, staticRenderFns } from "./InstaGallery.vue?vue&type=template&id=2f8c7556&"
import script from "./InstaGallery.vue?vue&type=script&lang=js&"
export * from "./InstaGallery.vue?vue&type=script&lang=js&"
import style0 from "./InstaGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports